/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Hour/Content"
  
}) {
let eventAppointmentBookingLocalStartDateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.local_start_date',
})
let eventAppointmentBookingLocalStartTimeValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.local_start_time',
})
let aggregateData = fromHelpers.formatHour(eventAppointmentBookingLocalStartDateValueData, eventAppointmentBookingLocalStartTimeValueData)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="regular"
 color={dtColorsNeutral700}
 data="event.appointment.booking.local_start_date"
 data="event.appointment.booking.local_start_time"
 aggregate="helpers.js formatHour"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}